import { berthApiClient } from '../berthApiClient'

import { getPreviousBookingEndpoint } from './endpoint'
import type {
  GetPreviousBookingResponse,
  PreviousBookingData,
  PreviousBookingOverrideParams,
} from './type'

export const getPreviousBooking = async (
  bookingId: string,
  overrideParams?: PreviousBookingOverrideParams
): Promise<PreviousBookingData | null> => {
  const res = await berthApiClient.get<GetPreviousBookingResponse>(getPreviousBookingEndpoint, {
    params: {
      bookingId,
      ...overrideParams,
    },
  })
  return res.data?.data ?? null
}
